import { Report } from './models';
import { pathCombine } from '../../core/api/module';
import { BaseUrl } from '../../core/api/endpoints';


export const downloadURL = (report: Report) => {
  const baseUrl = pathCombine(BaseUrl, '/report/reportDownload');
  return report?.fileExists ? baseUrl + '/' + encodeURIComponent(report!.reportFile) : undefined;
};
